$(document).ready(function() {

    $('.menu-toggle').on('click', function() {
        $(this).toggleClass('active');
        $(this).siblings('.mainnav-child-list').toggleClass('active');
    });

    // sidebar
    $('.sidebar-menu__toggle').on('click', function() {
        $(this).toggleClass('open');
        $(this).siblings('.sidebar-menu__sublist').toggleClass('open');
    });

});